/* unplugin-vue-components disabled */import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
/**
 * 该组件除了 Menu，也被 Breadcrumb 使用过
 * */
import { mapState } from 'vuex';
import tTitle from '../mixins/translate-title';
export default {
  name: 'iMenuHeadTitle',
  mixins: [tTitle],
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    badge: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('admin/menu', ['headerMenuBadge'])), {}, {
    badgeData: function badgeData() {
      var _this = this;
      var data = null;
      var headerMenuBadge = this.headerMenuBadge.find(function (item) {
        return item.path === _this.item.path;
      });
      if (headerMenuBadge) data = headerMenuBadge;
      return data;
    }
  })
};